import { render, staticRenderFns } from "./DevWorkingConditionsDetail.vue?vue&type=template&id=28afb5bf&"
import script from "./DevWorkingConditionsDetail.vue?vue&type=script&lang=js&"
export * from "./DevWorkingConditionsDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports